<template>
  <v-dialog 
    v-model="open" 
    @click:outside="$emit('close')"
    width="500"
  >
    <v-card>
      <i class="mdi mdi-close close-icon" @click="$emit('close')"></i>
      <v-card-title class="d-flex justify-content-center">Alerta !</v-card-title>
      <v-divider></v-divider>
      <div class="col-md-12 d-flex flex-column align-items-center">
      <p class="m-0">Tem certeza que deseja deletar está analise ?</p>
      <v-btn class="error my-6" @click="$emit('delete')"><i class="mdi mdi-delete"></i> Deletar</v-btn>
    </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name:"AlertModal",
  props:{
    open:Boolean
  }
}
</script>

<style scoped>
  .close-icon {
    right: 10px;
    top: 10px;
    position: absolute;
    font-size: 1.3rem;
    cursor: pointer;
  }
</style>